import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";

export interface IntempusState {
  hasIntegration: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: IntempusState = {
  hasIntegration: false,
  isLoading: true,
  error: null,
};

export const checkIntempusIntegration = createAsyncThunk(
  "intempus/checkIntegration",
  async () => {
    const { data } = await axios.get<{ has_integration: boolean }>(
      "/v1/integrations/intempus/status/",
    );
    return data.has_integration;
  },
);

const intempusSlice = createSlice({
  name: "intempus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkIntempusIntegration.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkIntempusIntegration.fulfilled, (state, action) => {
        state.hasIntegration = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(checkIntempusIntegration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to check integration";
      });
  },
});

export default intempusSlice.reducer;
